import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LuClipboardCheck, LuChevronRight } from "react-icons/lu";
import { REQUESTS } from "../../../routes/RouteConstant";

const PAGE_SIZE = 5;

export default function PendingApprovalTable({ items = [], loading }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  const openRequest = (id) => navigate(`${REQUESTS}?status=new&highlight=${id}`);
  const totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
  const start = (page - 1) * PAGE_SIZE;
  const visible = items.slice(start, start + PAGE_SIZE);

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
        <div className="flex items-center gap-2">
          <LuClipboardCheck size={15} className="text-gray-400" />
          <h3 className="text-[13px] font-semibold text-gray-900">Pending Approval</h3>
        </div>
        <span className="text-[11px] text-gray-400">{items.length} total</span>
      </div>

      {loading && (
        <div className="flex items-center justify-center py-10">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-700" />
        </div>
      )}

      {!loading && items.length === 0 && (
        <p className="px-4 py-8 text-center text-[12.5px] text-gray-400">
          No requests are currently awaiting approval.
        </p>
      )}

      {!loading && items.length > 0 && (
        <>
          <div className="divide-y divide-gray-100">
            {visible.map((item) => (
              <button
                type="button"
                key={item.id}
                onClick={() => openRequest(item.id)}
                title="Open in Requests to approve"
                className="group flex w-full items-center justify-between gap-3 px-4 py-2.5 text-left transition-colors hover:bg-gray-50"
              >
                <div className="min-w-0">
                  <p className="truncate text-[12.5px] font-medium text-gray-800 group-hover:text-brand-700">{item.item}</p>
                  <p className="truncate text-[11px] text-gray-400">by {item.by}</p>
                </div>
                <span className="flex shrink-0 items-center gap-1 text-[11px] text-gray-400">
                  {new Date(item.date).toLocaleDateString()}
                  <LuChevronRight size={13} className="text-gray-300 group-hover:text-gray-600" />
                </span>
              </button>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="flex items-center justify-between border-t border-gray-100 px-4 py-2">
              <button
                type="button"
                disabled={page <= 1}
                onClick={() => setPage((p) => p - 1)}
                className="text-[11.5px] font-medium text-gray-500 hover:text-gray-800 disabled:cursor-not-allowed disabled:opacity-40"
              >
                Previous
              </button>
              <span className="text-[11px] text-gray-400">
                Page {page} of {totalPages}
              </span>
              <button
                type="button"
                disabled={page >= totalPages}
                onClick={() => setPage((p) => p + 1)}
                className="text-[11.5px] font-medium text-gray-500 hover:text-gray-800 disabled:cursor-not-allowed disabled:opacity-40"
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}